var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.hasUser
        ? _vm._t("default")
        : _c(
            "div",
            [
              _vm.isLoading ? _c("loading-indicator") : _c("login-form"),
              _vm._v(" "),
              _vm.errorMsg
                ? _c("b-alert", { attrs: { variant: "danger", show: "" } }, [
                    _vm._v(_vm._s(_vm.errorMsg))
                  ])
                : _vm._e()
            ],
            1
          )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e4c8a19", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e4c8a19","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/RequiringUser.vue
// module id = null
// module chunks = 